import React from 'react';
import { auth } from '../../firebase.js';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const BtnLogOut = () => {
	const navigate = useNavigate();

	const cerrarSesion = async () => {
		try {
			await signOut(auth);
			navigate('/');
		} catch (error) {
			console.log(error);
		}
	}

	return (
		<div className='btn-LogOut'>
			<button className='btn btn-warning btn-lg btn-block' onClick={cerrarSesion}>Cerrar Sesión</button>
		</div>
	);
}

export default BtnLogOut;
